import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router-dom'
import { supplierMeta } from '../routes/metaData'
const DefaultNccScreen = observer((props: any) => {
   const history = useHistory()
   useEffect(() => {
      history.push(supplierMeta[0].path)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   return null
})

export default DefaultNccScreen
